import { TimeRange } from '@app/core/range';
import { getRangeForSegments } from '../../helpers/get-range-for-segments';
import { hasPartialSegmentCoverage } from '../../helpers/has-partial-segment-coverage';
import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useStreamSegments } from './useStreamSegmentsQuery';

export interface PartialSegmentCoverageState {
  hasPartialCoverage: boolean;
  segmentsRange: TimeRange | null;
}

/**
 * Returns whether loaded segments cover only part of the user-requested range,
 * and the actual segment coverage when partial.
 */
export function usePartialSegmentCoverage(): PartialSegmentCoverageState {
  const userRange = useStreamUserDefinedRange();
  const { segments, isLoading: isLoadingSegments } = useStreamSegments();

  if (isLoadingSegments || userRange.isLoading || segments.length === 0) {
    return { hasPartialCoverage: false, segmentsRange: null };
  }

  const segmentsRange = getRangeForSegments(segments);
  if (!segmentsRange.from || !segmentsRange.to) {
    return { hasPartialCoverage: false, segmentsRange: null };
  }

  return {
    hasPartialCoverage: hasPartialSegmentCoverage(userRange, segmentsRange),
    segmentsRange,
  };
}
